import { render, staticRenderFns } from "./limitWelfare.vue?vue&type=template&id=3b0a94eb"
import script from "./limitWelfare.vue?vue&type=script&lang=js"
export * from "./limitWelfare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-hmt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0a94eb')) {
      api.createRecord('3b0a94eb', component.options)
    } else {
      api.reload('3b0a94eb', component.options)
    }
    module.hot.accept("./limitWelfare.vue?vue&type=template&id=3b0a94eb", function () {
      api.rerender('3b0a94eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/limitWelfare.vue"
export default component.exports